import React, {
  useState,
  useEffect,
  useRef
} from "react";

import {
  FaBars,
  FaWhatsapp
} from "react-icons/fa";

import {
  Link,
  useNavigate,
  useLocation
} from "react-router-dom";

import logo from "../assets/deoria_logo.png";

const Header = ({ toggleSidebar }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const [aboutOpen, setAboutOpen] =
    useState(false);

  const [academicOpen, setAcademicOpen] =
    useState(false);

  const [stickyNav, setStickyNav] =
    useState(false);

  /* refs for outside click */
  const aboutRef = useRef(null);
  const academicRef = useRef(null);

  /* close when click outside */
  useEffect(() => {
    const handleClickOutside = (
      event
    ) => {
      if (
        aboutRef.current &&
        !aboutRef.current.contains(
          event.target
        )
      ) {
        setAboutOpen(false);
      }

      if (
        academicRef.current &&
        !academicRef.current.contains(
          event.target
        )
      ) {
        setAcademicOpen(false);
      }
    };

    document.addEventListener(
      "mousedown",
      handleClickOutside
    );

    return () => {
      document.removeEventListener(
        "mousedown",
        handleClickOutside
      );
    };
  }, []);

  /* close all dropdowns when route changes */
  useEffect(() => {
    setAboutOpen(false);
    setAcademicOpen(false);
  }, [location]);

  /* sticky nav only */
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 115) {
        setStickyNav(true);
      } else {
        setStickyNav(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () =>
      window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      {/* HEADER */}
      <header className="header ep-header">

        {/* LEFT */}
        <button
          className="left-menu-btn"
          onClick={toggleSidebar}
        >
          <FaBars />
        </button>

        {/* LOGO */}
        <div className="logo-section">
          <Link to="/">
            <img
              src={logo}
              alt="logo"
              className="school-logo"
            />
          </Link>
        </div>

        {/* RIGHT */}
        <div className="header-right">

          <button
            className="login-text-btn"
            onClick={() =>
              navigate("/student-tc")
            }
          >
            Student TC
          </button>

          <a
            href="https://wa.me/6387495591"
            target="_blank"
            rel="noreferrer"
            className="whatsapp-btn"
          >
            <FaWhatsapp />
          </a>

          <button
            className="login-text-btn"
            onClick={() =>
              navigate("/admin/login")
            }
          >
            LOGIN
          </button>

        </div>
      </header>

      {/* NAVBAR */}
      <nav
        className={`main-navbar ${stickyNav ? "sticky-nav" : ""
          }`}
      >

        <Link to="/">Home</Link>

        {/* ABOUT */}
        <div
          className="nav-item dropdown"
          ref={aboutRef}
        >
          <span
            onClick={() => {
              setAboutOpen(
                !aboutOpen
              );
              setAcademicOpen(
                false
              );
            }}
          >
            About ▾
          </span>

          {aboutOpen && (
            <div className="mega-menu">
              <div className="mega-links">
                <Link
                  to="/about?tab=history"
                  onClick={() => setAboutOpen(false)}
                >
                  History
                </Link>

                <Link
                  to="/about?tab=aims"
                  onClick={() => setAboutOpen(false)}
                >
                  Aims & Objectives
                </Link>

                <Link
                  to="/about?tab=director"
                  onClick={() => setAboutOpen(false)}
                >
                  Director's Desk
                </Link>

                <Link
                  to="/about?tab=principal"
                  onClick={() => setAboutOpen(false)}
                >
                  Principal's Desk
                </Link>

                <Link
                  to="/about?tab=coordinator"
                  onClick={() => setAboutOpen(false)}
                >
                  Coordinator's Desk
                </Link>

                <Link
                  to="/about?tab=committee"
                  onClick={() => setAboutOpen(false)}
                >
                  Committee & Members
                </Link>

                <Link
                  to="/about?tab=faculty"
                  onClick={() => setAboutOpen(false)}
                >
                  Faculty & Staff
                </Link>

                <Link
                  to="/about?tab=awards"
                  onClick={() => setAboutOpen(false)}
                >
                  Awards & Medals
                </Link>

                <Link
                  to="/about?tab=basic"
                  onClick={() => setAboutOpen(false)}
                >
                  Basic Details
                </Link>

              </div>
            </div>
          )}
        </div>

        <Link to="/admission">
          Admission
        </Link>

        <Link to="/parents">
          Parents
        </Link>

        {/* ACADEMICS */}
        <div
          className="nav-item dropdown"
          ref={academicRef}
        >
          <span
            onClick={() => {
              setAcademicOpen(
                !academicOpen
              );
              setAboutOpen(
                false
              );
            }}
          >
            Academics ▾
          </span>

          {academicOpen && (
            <div className="mega-menu">
              <div className="mega-links">

                <Link
                  to="/academics?tab=details"
                  onClick={() => setAcademicOpen(false)}
                >
                  Academics Details
                </Link>

                <Link
                  to="/academics?tab=overview"
                  onClick={() => setAcademicOpen(false)}
                >
                  Overview
                </Link>

                <Link
                  to="/academics?tab=curriculum"
                  onClick={() => setAcademicOpen(false)}
                >
                  Curriculum
                </Link>

                <Link
                  to="/academics?tab=student"
                  onClick={() => setAcademicOpen(false)}
                >
                  Student Detail
                </Link>

                <Link
                  to="/academics?tab=timing"
                  onClick={() => setAcademicOpen(false)}
                >
                  School Timing
                </Link>

                <Link
                  to="/academics?tab=dress"
                  onClick={() => setAcademicOpen(false)}
                >
                  School Dress
                </Link>

                <Link
                  to="/academics?tab=exam"
                  onClick={() => setAcademicOpen(false)}
                >
                  Exam Schedule
                </Link>

                {/* <Link
                  to="/academics?tab=fees"
                  onClick={() => setAcademicOpen(false)}
                >
                  Fees Schedule
                </Link> */}

                <Link
                  to="/academics?tab=other"
                  onClick={() => setAcademicOpen(false)}
                >
                  Other Vital Information
                </Link>
              </div>
            </div>
          )}
        </div>

        <Link to="/life">
          Life At School
        </Link>

        <Link to="/mandatory-public-disclosure">
          Mandatory Public Disclosure
        </Link>

        <Link to="/cbse-documents">
          CBSE Documents
        </Link>

        <Link to="/infrastructure">
          Infrastructure
        </Link>

        <Link to="/events">
          Events
        </Link>

        <Link to="/news">
          What's Happening
        </Link>

        <Link to="/gallery">
          Gallery
        </Link>

        <Link to="/facilities">
          Facility
        </Link>

        <Link to="/documents">
          Documents
        </Link>

        <Link to="/student-tc">
          Student TC
        </Link>

        <Link to="/contact">
          Contact
        </Link>

        <Link to="/virtual-tour">
          Virtual Tour
        </Link>

      </nav>
    </>
  );
};

export default Header;